import axios from 'axios';
import BASE_URL from '../config/apiConfig';

// Create axios instance for public APIs (no auth required)
const publicAPI = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


export const submitContactForm = async (contactData) => {
  try {
    const response = await publicAPI.post('/public/email/contact', {
      name: contactData.fullName,
      email: contactData.email,
      phone_number: contactData.phoneNumber || null,
      subject: contactData.product || 'General Inquiry',
      message: contactData.message,
      recaptcha_token: contactData.recaptchaToken || null,
    });
    
    return response.data;
  } catch (error) {
    console.error('❌ Error submitting contact form:', error.response?.data || error.message);
    throw error;
  }
};

export const submitTrialForm = async (trialData) => {
  try {
    const response = await publicAPI.post('/public/email/contact', {
      name: trialData.name,
      email: trialData.email,
      subject: `Demo Request - Goals: ${trialData.goals || 'Not specified'}`,
      message: `Hello,\n\nI would like to request a demo.\n\nHere are my goals:\n${trialData.goals || 'No specific goals mentioned.'}\n\nThank you.`,
    });

    return response.data;
  } catch (error) {
    console.error('❌ Error submitting trial form:', error.response?.data || error.message);
    throw error;
  }
};


export const submitSupportRequest = async (supportData) => {
  try {
    const response = await publicAPI.post('/public/email/support', {
      user_email: supportData.user_email,
      issue_type: supportData.issue_type,
      description: supportData.description,
    });
    
    return response.data;
  } catch (error) {
    console.error('❌ Error submitting support request:', error.response?.data || error.message);
    throw error;
  }
};


export const submitFeedback = async (feedbackData) => {
  try {
    const response = await publicAPI.post('/public/email/feedback', {
      name: feedbackData.name,
      user_email: feedbackData.email,
      feedback_type: feedbackData.feedback_type || feedbackData.category || 'general',
      rating: feedbackData.rating ?? undefined,
      comments: feedbackData.comments ?? feedbackData.message,
    });

    return response.data;
  } catch (error) {
    console.error('❌ Error submitting feedback:', error.response?.data || error.message);
    throw error;
  }
};


